import "./chord.css";
import React, { useState } from "react";
function String(props) {
  const notes = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B",
  ];
  return (
    <div className="flex">
      <div className="fret">
        {props.fret.map((elm, index) => {
          let cls = "finger ";
          if (elm === 1) cls += "pushed ";
          if (index === 0) cls += "open";
          return (
            <button
              onClick={(e) => {
                props.clickHandler([props.key, index], elm);
              }}
              className={cls}
              key={index}
            >
              {notes[(props.base + index) % 12]}
            </button>
          );
        })}
      </div>
    </div>
  );
}

function Board(props) {
  const board = [];
  for (let i = 0; i < 6; i++) board.push(Array(12).fill(0));
  props.pos.forEach((elm) => {
    if (-1 < elm[0] && elm[0] < 6 && -1 < elm[1] && elm[1] < board[0].length)
      board[elm[0]][elm[1]] = 1;
  });
  return (
    <div>
      {props.base.map((b, index) =>
        String({
          base: b,
          fret: board[index],
          clickHandler: props.clickHandler,
          key: index,
        })
      )}
      <div className="flex">
        <div className="fret">
          <button className="finger sign">開放</button>
          <button className="finger sign">1</button>
          <button className="finger sign">2</button>
          <button className="finger sign">3</button>
          <button className="finger sign">4</button>
          <button className="finger sign">5</button>
          <button className="finger sign">6</button>
          <button className="finger sign">7</button>
          <button className="finger sign">8</button>
          <button className="finger sign">9</button>
          <button className="finger sign">10</button>
          <button className="finger sign">11</button>
        </div>
      </div>
    </div>
  );
}

function Chord(props) {
  const notes = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B",
  ];
  let heights = []; // 鳴ってる音
  let comp = []; // コード構成音
  props.pos.forEach((n) => {
    if (0 <= n[0] && n[0] < props.base.length && n[1] >= 0) {
      const tmp = props.base[n[0]] + n[1];
      if (tmp >= 0) heights.push(tmp);
    }
  });
  heights = heights.sort((a, b) => a - b);

  const exist = new Set(); // 倍音除去用

  let onNote = notes[heights[0] % 12]; // 一番低い音
  const root = heights[0] % 12; // 一番低い音をルートに

  comp.push(heights[0] % 12);
  exist.add(heights[0] % 12);

  heights.forEach((elm) => {
    // 構成音抽出
    if (!exist.has(elm % 12)) {
      comp.push(elm);
      exist.add(elm % 12);
    }
  });
  let comp2 = comp // root差分
    .map((elm) => {
      let ans = (elm % 12) - root;
      if (ans < 0) ans += 12;
      return ans;
    })
    .sort((a, b) => a - b);
  const noteComp = comp2.map((elm, index) => notes[(elm + root) % 12]);

  // コード算出
  let cnt = 0;
  const calcChord = () => {
    console.log("calc", comp2, cnt);
    const table = [
      { name: "add9", ptn: [0, 2, 4, 7] },
      { name: "dim", ptn: [0, 3, 6, 9] },
      { name: "dim", ptn: [0, 3, 6] },
      { name: "m7-5", ptn: [0, 3, 6, 10] },
      { name: "m", ptn: [0, 3, 7] },
      { name: "m6", ptn: [0, 3, 7, 9] },
      { name: "m7", ptn: [0, 3, 7, 10] },
      { name: "mM7", ptn: [0, 3, 7, 11] },
      { name: "m7-5", ptn: [0, 4, 6, 10] },
      { name: "msus4", ptn: [0, 3, 5, 7] },
      { name: "", ptn: [0, 4, 7] },
      { name: "6", ptn: [0, 4, 7, 9] },
      { name: "7", ptn: [0, 4, 7, 10] },
      { name: "M7", ptn: [0, 4, 7, 11] },
      { name: "aug", ptn: [0, 4, 8] },
      { name: "sus2", ptn: [0, 2, 7] },
      { name: "sus4", ptn: [0, 5, 7] },
      { name: "7sus4", ptn: [0, 5, 7, 10] },
      { name: "mj9", ptn: [0, 2, 4, 7, 11] },
      { name: "mj9", ptn: [0, 2, 4, 11] },
    ];
    let ans = "";
    table.forEach((elm) => {
      if (elm.ptn.length === comp2.length) {
        let wow = true;
        elm.ptn.forEach((c, index) => {
          if (c !== comp2[index]) wow = false;
        });
        if (wow) {
          ans = noteComp[cnt] + elm.name;
          if(cnt>0)ans += "/" + onNote
          console.log("cotcha", noteComp, cnt);
        }
      }
    });
    if (ans === "" && cnt < 10) {
      cnt++;
      let diff = comp2[1];
      comp2.forEach((elm, index) => {
        let aho = (elm - diff) % 12;
        if (aho < 0) aho += 12;
        comp2[index] = aho;
      });
      comp2 = comp2.sort((a, b) => a - b);
      return calcChord();
    }
    return ans;
  };
  return (
    <div>
      <div className={"root"}>: {calcChord()}</div>
      <p>
        {heights.map((elm, index) => (
          <span key={index}>{notes[elm % 12]}, </span>
        ))}
      </p>
      <p>
        {comp2.map((elm, index) => (
          <span className={"sound"} key={index}>
            {elm}
          </span>
        ))}
      </p>
      <p>
        {comp.map((elm, index) => (
          <span className={"sound"} key={index}>
            {notes[elm % 12]}
          </span>
        ))}
      </p>
    </div>
  );
}

function Manage() {
  const [base] = useState([28, 23, 19, 14, 9, 4]);
  const [pos, setPos] = useState([
    [0, 0],
    [1, 0],
    [2, 1],
    [3, 2],
    [4, 2],
    [5, 0],
  ]);
  const clickHandler = (cor, now) => {
    if (now === 1)
      setPos(pos.filter((elm) => !(elm[0] === cor[0] && elm[1] === cor[1])));
    else {
      let tmp = pos.slice();
      tmp = tmp.filter((elm) => elm[0] !== cor[0]);
      tmp.push(cor);
      setPos(tmp);
    }
  };
  const force = (c) => {
    if (c === "F") {
      setPos([
        [0, 1],
        [1, 1],
        [2, 2],
        [3, 3],
        [4, 3],
        [5, 1],
      ]);
    }
    if (c === "NC") {
      setPos([]);
    }
    return;
  };
  const move = (d) => {
    const tmp = pos.slice();
    if (d === "r") {
      tmp.forEach((elm) => {
        elm[1]++;
      });
    } else if (d === "l") {
      tmp.forEach((elm) => {
        elm[1]--;
      });
    } else if (d === "t") {
      tmp.forEach((elm) => {
        if (elm[0] === 2) {
          elm[0]--;
          elm[1]++;
        } else elm[0]--;
      });
    } else if (d === "d") {
      tmp.forEach((elm) => {
        if (elm[0] === 1) {
          elm[0]++;
          elm[1]--;
        } else elm[0]++;
      });
    } else return;
    setPos(tmp);
  };
  return (
    <div class="select-none">
      {Board({ base: base, pos: pos, clickHandler: clickHandler })}
      <button className="arrow" onClick={() => move("l")}>
        ←
      </button>
      <button className="arrow" onClick={() => move("d")}>
        ↓
      </button>
      <button className="arrow" onClick={() => move("t")}>
        ↑
      </button>
      <button className="arrow" onClick={() => move("r")}>
        →
      </button>

      {Chord({ base: base, pos: pos })}
      <button className="chord" onClick={() => force("F")}>
        F
      </button>
      <button className="chord" onClick={() => force("NC")}>
        NC
      </button>
    </div>
  );
}
export default Manage;
